import Vue from 'vue';
import Moment from 'moment';

const checkDayDate = (value) => {
  switch (value) {
    case 'Monday':
      return 'Segunda-Feira';
    case 'Tuesday':
      return 'Terça-Feira';
    case 'Wednesday':
      return 'Quarta-Feira';
    case 'Thursday':
      return 'Quinta-Feira';
    case 'Friday':
      return 'Sexta-Feira';
    case 'Saturday':
      return 'Sábado';
    case 'Sunday':
      return 'Domingo';
    default:
      return value;
  }
};

Vue.filter('dateBR', (value) => (value ? Moment(String(value)).format('DD/MM/YYYY') : value));
Vue.filter('dateHourBR', (value) => (value ? Moment(String(value)).format('DD/MM/YYYY HH:mm') : value));
Vue.filter('dateStr', (value) => (value ? checkDayDate(Moment(String(value)).format('dddd')) : value));
